"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Field_1 = __importDefault(require("@becrop/abstract/Models/Field"));
class FieldAnalytics extends Field_1.default {
    constructor(fieldDefaultData, breakdownRecommendations, breakdownNeeds, breakdownMetrics, cropsAnalytics, breakdownPHCH) {
        super(fieldDefaultData);
        this.breakdownRecommendations = breakdownRecommendations;
        this.breakdownNeeds = breakdownNeeds;
        this.breakdownMetrics = breakdownMetrics;
        this.breakdownPHCH = breakdownPHCH;
        this.cropsAnalytics = cropsAnalytics;
    }
}
exports.default = FieldAnalytics;
